import { useEffect, useRef } from 'react';

/**
 * 前回のレンダリング時の値を保持するカスタムフック
 * @param value 追跡する値
 * @returns 前回のレンダリング時の値（初回はundefined）
 */
export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T | undefined>(undefined);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};
